// Runtime configuration comes from public/config.js, which sets window.APP_CONFIG
// before the bundle loads. Reading it at call time (rather than import time) keeps
// this module safe to import from anywhere.
const config = () => window.APP_CONFIG || {};

export const apiBaseUrl = () => config().apiBaseUrl;

export const analyticsEnabled = () => config().analytics === true;
